import React from 'react';
import PropTypes from 'prop-types';
import PopUp from '@/components/Modal/PopUp';
import Friend from '@/assets/images/readingShare/share_icon_wx_nor@2x.png';
import Moments from '@/assets/images/readingShare/share_icon_pyq_nor@2x.png';
import './style.less';

const ShareModal = ({
  hide,
  fade,
  share,
  shareBtn,
}) => (
  <PopUp hide={hide}>
    <div className={`share-modal ${fade}`}>
      <div className="friend" onClick={shareBtn ? () => share('WEIXIN') : null}>
        <img src={Friend} alt="" />
        微信好友
      </div>
      <div className="moments" onClick={shareBtn ? () => share('WEIXIN_CIRCLE') : null}>
        <img src={Moments} alt="" />
        微信朋友圈
      </div>
      <div className="cancel" onClick={hide}>
        取消
      </div>
    </div>
  </PopUp>
);

ShareModal.propTypes = {
  fade: PropTypes.string,
  hide: PropTypes.func,
  share: PropTypes.func,
  shareBtn: PropTypes.bool,
};

export default ShareModal;
